import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MODAL_EDITOR_TOKEN, ModalEditorBase } from '../../../classes/modal-editor-base';

@Component({
    selector: 'ft-booking-option-text-editor',
    templateUrl: './booking-option-text-editor.component.html',
    styleUrls: ['./booking-option-text-editor.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => BookingOptionTextEditorComponent)
        },
        {
            provide: MODAL_EDITOR_TOKEN,
            useExisting: BookingOptionTextEditorComponent
        }
    ],
    standalone: false
})
export class BookingOptionTextEditorComponent extends ModalEditorBase {
    @Input() bindLabel: string = 'label';
    @Input() bindSummary: string = 'summary';
    @Input() bindDescription: string = 'description';


    isInvalid(): boolean {
        return this.controlsModelRef.some(input => input.invalid) || false;
    }
}
